
<div class="waiting-spinner-container">
    <div class="waiting-spinner-container-inside">
        <div class="waiting-spinner-text">
            {{waitingMessage}} ({{progressIndicator}}%)
        </div>  
        <mat-progress-bar class="progress-bar-style" mode="determinate" [value]="progressIndicator"></mat-progress-bar> 
    </div>
</div>